<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="inputRect">
      <van-field
        v-model="account"
        required
        clearable
        label="序号"
        placeholder="请输入序号"
      />

      <div class="buttonRect">
        <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onSave">保存</van-button>
      </div>
    </div>
    <div class="regAbout">
      1.请输入<b>{{ groupType }}</b>专业用户序号,一旦提交需要联系潜店管理人员才可修改。请谨慎提交；<br>
      2.错误或者不可用的证书编码将会导致证书签发异常,影响用户证书签发。
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast, Dialog } from 'vant'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    groupType:undefined
  },
  data() {
    return {
      title: '关联第三方账号',
      showBind: false,
      buttonLoading: false,
      account: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showBind = true
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {

    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onSave() {
      if (!this.account) {
        MyNotify('info', '请输入序号')
        return
      }
      Dialog.confirm({
        title: '确认绑定' + this.groupType + '专业用户序号',
        message: '是否要绑定' + this.groupType + '专业用户序号： ' + this.account + '？一旦提交后不可自行修改。'
      }).then(() => {
        this.onSaveDo()
      })
    },
    onSaveDo() {
      this.buttonLoading = true
      request({
        url: '/pro/setThirdGroupAccountId',
        method: 'post',
        data: {
          groupType: this.groupType,
          account: this.account
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.showBind = false
        Toast.success('绑定成功!')
        this.$emit('reload')
      })
    }

  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
